import React, { useState, useEffect } from 'react';

import CircularProgress from '@mui/material/CircularProgress';
import FormHelperText from '@mui/material/FormHelperText';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Input from '@mui/material/Input';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

import $ from 'jquery';
import mainURL from '../../config/environment';

import { formatPhone } from '../../formatPhone';

const emptyModel = {
  name: '',
  address: '',
  mapURL: '',
  mapTitle: '',
  phoneNumber: '',
  photo: '',
};

export default function UpdateClientDialog(props) {
  const [isFormComplete, setFormComplete] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [model, setModel] = useState(emptyModel);
  const { refresh } = props;
  const { clientId } = props;

  const handleChange = (event) => {
    const target = event.target;
    const name = target.name;
    let value = target.value;

    setModel({
      ...model,
      [name]: value,
    });

    if (model.name !== '') {
      setFormComplete(true);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    const token = JSON.parse(localStorage.getItem('userInfo')).token;

    $.ajax({
      method: 'PUT',
      url: mainURL + `client/${clientId}`,
      contentType: 'application/json',
      headers: {
        Authorization: 'Bearer ' + token,
      },
      data: JSON.stringify(model),
    })
      .done((res) => {
        setLoading(false);
        props.handleShowNotification('success', 'Client updated successfully');
        handleClear();
      })
      .fail((res) => {
        setLoading(false);

        props.handleShowNotification('error', res.responseText);
        handleClear();
      });
  };

  const handleClear = () => {
    props.handleClose();
    setModel(emptyModel);
    props.setRefresh(!refresh);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    let reader = new FileReader();
    reader.onload = (e) => {
      let image = e.target.result;
      setModel({ ...model, photo: image });
    };
    reader.readAsDataURL(file);

    if (model.name !== '') {
      setFormComplete(true);
    }
  };

  const handlePhoneChange = (e) => {
    const raw = e.target.value;
    const formatted = formatPhone(raw);
    setModel((prev) => ({ ...prev, phoneNumber: formatted }));
  };

  useEffect(() => {
    const token = JSON.parse(localStorage.getItem('userInfo')).token;
    const host = JSON.parse(localStorage.getItem('userInfo')).hostName;
    if (clientId !== '') {
      $.ajax({
        method: 'GET',
        url: mainURL + 'client/' + clientId,
        contentType: 'application/json',
        headers: {
          Authorization: 'Bearer ' + token,
          hostname: host,
        },
      }).done((res) => {
        setModel(res);
      });
    }
  }, [clientId, refresh]);

  return (
    <Dialog open={props.open} onClose={props.handleClose} maxWidth="md">
      <DialogTitle>{'Edit client'}</DialogTitle>
      <DialogContent>
        <Box component="form" onSubmit={handleSubmit}>
          <FormControl fullWidth required sx={{ mt: 1 }}>
            <TextField
              label={'Name'}
              onChange={handleChange}
              value={model.name}
              variant="standard"
              name="name"
              margin="dense"
              type="text"
              fullWidth
              autoFocus
              required
            />
          </FormControl>
          <FormControl fullWidth required sx={{ mt: 1 }}>
            <TextField
              label={'Address'}
              onChange={handleChange}
              value={model.address}
              variant="standard"
              name="address"
              margin="dense"
              type="text"
              fullWidth
              required
            />
          </FormControl>
          <FormControl fullWidth sx={{ mt: 1 }}>
            <TextField
              label={'Phone number'}
              onChange={handlePhoneChange}
              value={model.phoneNumber}
              variant="standard"
              name="phoneNumber"
              margin="dense"
              type="text"
              fullWidth
            />
          </FormControl>
          <FormControl fullWidth required sx={{ mt: 1 }}>
            <TextField
              label={'Website URL'}
              onChange={handleChange}
              value={model.websiteURL}
              variant="standard"
              name="websiteURL"
              margin="dense"
              type="text"
              fullWidth
            />
          </FormControl>
          <FormControl fullWidth required sx={{ mt: 1 }}>
            <InputLabel variant="standard">{'Client logo'}</InputLabel>
            <Input type="file" onChange={handleFileChange} />
            <FormHelperText variant="standard">Client logo</FormHelperText>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        {isLoading ? (
          <Grid container justifyContent={'center'}>
            <CircularProgress />
          </Grid>
        ) : (
          <Grid container justifyContent={'flex-end'}>
            <Button type="submit" onClick={handleClear}>
              Close
            </Button>
            <Button type="submit" disabled={!isFormComplete} onClick={handleSubmit}>
              Update
            </Button>
          </Grid>
        )}
      </DialogActions>
    </Dialog>
  );
}
